import { CoreExecutorResult } from "../../core/index.js";
import { DataPsmExecutorResultFactory } from "./data-psm-executor-utils.js";
import { DataPsmSchema } from "../model/index.js";
export async function executeDataPsmSetJsonEnforceContext(reader, createNewIdentifier, operation) {
    const resource = await reader.readResource(operation.dataPsmEntity);
    if (resource == null || !DataPsmSchema.is(resource)) {
        return DataPsmExecutorResultFactory.invalidType(resource, "data-psm schema");
    }
    if (operation.jsonEnforceContext === undefined) {
        const clonedResource = { ...resource };
        delete clonedResource.jsonEnforceContext;
        CoreExecutorResult.createSuccess([], [clonedResource]);
    }
    return CoreExecutorResult.createSuccess([], [
        {
            ...resource,
            jsonEnforceContext: operation.jsonEnforceContext,
        },
    ]);
}
//# sourceMappingURL=data-psm-set-json-enforce-context-executor.js.map